import uniqid from "uniqid";

import ReservationRow from "./ReservationRow";
import ReservationPopUp from "./ReservationPopUp";
import TitleCell from "../../common/List/TitleCell";
import List from "../../common/List/List";

import { useEffect, useState } from "react";
import { fetchWithToken } from "../../../functions/fetch";
import { useUpdateTimeSlot } from "../../../contexts/updateTimeSlotContext";
import NewReservationPopUp from "./NewReservationPopUp";
import { useDisclosure } from "@chakra-ui/react";
import NewItemButton from "../../common/NewItemButton";

const ReservationList = ({
  reservations,
  canDelete,
  isOverdue,
  timeSlots,
  setFunction,
  setTimeSlots,
  setRefetchReservation,
}) => {
  const rowText = [
    "預約日期",
    "星期",
    "時段",
    "目的",
    "預定房號",
    "會員編號",
    "姓名",
    "聯絡電話",
    "身分",
    "職業",
    "使用者備註",
    "備註",
  ];

  const [showPopUp, setShowPopUp] = useState(false);
  const [curReservation, setCurReservation] = useState(null); // current selected reservation(for editing)
  const { updateTimeSlot, setUpdateTimeSlot } = useUpdateTimeSlot();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const fetchTimeSlot = async () => {
    const res = await fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/time-slot`,
    );
    if (res.status === 200) {
      setTimeSlots(res.data);
    } else {
      console.error(res);
    }
  };

  useEffect(() => {
    if (updateTimeSlot) {
      fetchTimeSlot();
      setUpdateTimeSlot(false);
    }
  }, [updateTimeSlot]);

  return (
    <div>
      {showPopUp ? (
        <ReservationPopUp
          setFunction={setFunction}
          reservation={curReservation}
          canDelete={canDelete}
          setShowPopUp={setShowPopUp}
          isOverdue={isOverdue}
          timeSlots={timeSlots}
          setRefetchReservation={setRefetchReservation}
        />
      ) : (
        <></>
      )}
      <NewReservationPopUp
        isOpen={isOpen}
        onClose={onClose}
        setRefetchReservation={setRefetchReservation}
      />
      <div className="border-t-2 w-full pt-8" />
      <NewItemButton itemName="預約" setShowPopUp={onOpen} />
      <List gridCols="grid-cols-[repeat(10,min-content)_1fr_1fr]">
        {rowText.map((text) => (
          <TitleCell key={uniqid()} text={text} />
        ))}
        {reservations ? (
          reservations.map((reservation) => (
            <ReservationRow
              key={uniqid()}
              reservation={reservation}
              setShowPopUp={setShowPopUp}
              setCurReservation={setCurReservation}
            />
          ))
        ) : (
          <p>No reservation</p>
        )}
      </List>
    </div>
  );
};

export default ReservationList;
